// Import Redux utility to combine multiple reducers into one
import { combineReducers } from "redux";

// Import the main reducer handling global application state
import MainReducer from "./MainReducer";

// Combine all individual reducers into a single reducer object
// In this case, only MainReducer is used, but more can be added later
const combinedReducers = combineReducers({ MainReducer });

// Root reducer that delegates state and action to combined reducers
// Useful for adding custom logic like global reset in the future
const rootReducer = (state, action) => {
  return combinedReducers(state, action);
};

// Export the root reducer to be used when creating the Redux store
export default rootReducer;
